import { render, staticRenderFns } from "./ArchivioSpedizioniEditDetails.vue?vue&type=template&id=f5954f1c&scoped=true"
import script from "./ArchivioSpedizioniEditDetails.vue?vue&type=script&lang=js"
export * from "./ArchivioSpedizioniEditDetails.vue?vue&type=script&lang=js"
import style0 from "./ArchivioSpedizioniEditDetails.vue?vue&type=style&index=0&id=f5954f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5954f1c",
  null
  
)

export default component.exports